import React from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const sections = [
  {
    title: "Booking Conduct",
    body: [
      "Provide accurate address, contact, and service details when booking — this is what your assigned partner relies on to complete the job.",
      "Be reachable at the mobile number on your booking; a partner may need to confirm details or an OTP before starting work.",
      "Cancelling a booking may attract a charge depending on how far along it is — see our Cancellation Policy.",
    ],
  },
  {
    title: "Prohibited Use",
    body: [
      "Do not use the platform to request illegal work, or work that violates local safety or building regulations.",
      "Do not attempt to bypass the platform to pay a partner directly for a service booked through ClickNido, or solicit partners for off-platform work.",
      "Do not submit fraudulent bookings, fake reviews, or misuse promotional offers.",
    ],
  },
  {
    title: "Account Responsibility",
    body: [
      "You're responsible for activity on your account. Keep your login details private and let us know immediately if you suspect unauthorised access.",
      "One account per person — creating multiple accounts to bypass restrictions (e.g. repeated offer abuse) may result in suspension.",
    ],
  },
  {
    title: "Enforcement",
    body: [
      "Violating these rules may result in a warning, order cancellation, or account suspension, depending on severity.",
      "We'll always try to understand context before taking action — if you believe an enforcement decision was made in error, contact support.",
    ],
  },
];

const RulesRegulations = () => {
  const navigate = useNavigate();

  return (
    <div style={styles.page}>
      <div style={styles.container}>
        <div style={styles.breadcrumb}>Home &nbsp;›&nbsp; Rules &amp; Regulations</div>

        <h1 style={styles.title}>Rules &amp; Regulations</h1>
        <p style={styles.intro}>
          Ground rules for using ClickNido, so bookings stay fair, safe and reliable
          for everyone.
        </p>

        {sections.map((sec) => (
          <div key={sec.title} style={styles.card}>
            <h2 style={styles.cardTitle}>{sec.title}</h2>
            <ul style={styles.list}>
              {sec.body.map((line) => (
                <li key={line}>{line}</li>
              ))}
            </ul>
          </div>
        ))}

        <div style={styles.card}>
          <h2 style={styles.cardTitle}>Contact Us</h2>
          <p style={styles.contactText}>Questions about these rules? Reach out to us anytime.</p>
          <button style={styles.inlineLink} onClick={() => navigate("/contact-us")}>
            Contact Us <ArrowRight size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};

const styles = {
  page: {
    background: "#f5f6fb",
    minHeight: "100vh",
    padding: "40px 16px",
    fontFamily:
      "Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    color: "#111827",
  },
  container: { maxWidth: "860px", margin: "0 auto" },
  breadcrumb: { color: "#7b8198", fontSize: "13px", fontWeight: 600, marginBottom: "14px" },
  title: { margin: 0, fontSize: "32px", fontWeight: 800, color: "#1c2148", marginBottom: "12px" },
  intro: { margin: "0 0 28px", fontSize: "15px", lineHeight: 1.75, color: "#5c6480", maxWidth: "700px" },
  card: {
    background: "#fff",
    borderRadius: "20px",
    padding: "26px",
    boxShadow: "0 1px 2px rgba(16,24,40,0.04), 0 8px 28px rgba(16,24,40,0.04)",
    marginBottom: "18px",
  },
  cardTitle: { margin: "0 0 14px", fontSize: "17px", fontWeight: 800, color: "#21284d" },
  list: { margin: 0, paddingLeft: "20px", color: "#5c6480", fontSize: "14px", lineHeight: 1.9 },
  contactText: { margin: "0 0 14px", fontSize: "14px", lineHeight: 1.8, color: "#5c6480" },
  inlineLink: {
    background: "transparent",
    border: "none",
    color: "#6d5efc",
    fontWeight: 700,
    fontSize: "14px",
    display: "inline-flex",
    alignItems: "center",
    gap: "8px",
    cursor: "pointer",
    padding: 0,
  },
};

export default RulesRegulations;
